import MuiTypography from '@mui/material/Typography';
import { Stack, Box } from '@mui/system';
import dayjs from 'dayjs';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import _ from 'lodash';
import {
  Status,
  StatusDefault as StatusBooking,
} from '../../booking/conf/Data.conf';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import operations from '../index';
import { API } from '../api';
import RectangleChip from '../../../components/common/RectangleChip.component';
import { DepartmentsConf } from '../../../core/dashboard/conf/Data.conf';
import { Checkbox, Chip, Grid, Tooltip, IconButton } from '@mui/material';
import { StatusBilling, StatusOperationBookingType } from './Data.conf';
import TextField from '../../../components/form/components/TextField.component';
import SelectCustom from '../../../components/form/components/SelectCustom.component';
import { Link } from 'react-router-dom';
import AnchorIcon from '@mui/icons-material/Anchor';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: {
      by: 'operation_date',
      direction: 'desc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'checkbox_select',
      key: 'checkbox_select',
      sort_key: '',
      sortable: false,
      label: '',
      checkbox: true,
      width: 40,
      selectable: true,
    },
    {
      id: 'attributes.id_yacht.data',
      key: 'yacht_name',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'Yacht Name',
      width: '200px',
    },
    {
      id: 'attributes.id_department.data.attributes.name_department',
      key: 'name_department',
      sort_key: 'id_department.name_department',
      sortable: true,
      label: 'Department',
      width: '150px',
    },
    {
      id: 'attributes.status_operation_booking_id',
      key: 'status_operation_booking_id',
      sort_key: 'status_operation_booking',
      sortable: true,
      label: 'Operational Status',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.service_reservation_request_id',
      key: 'service_reservation_request_id',
      sort_key: 'service_reservation_request_id',
      sortable: true,
      label: 'Service',
      width: '120px',
    },
    {
      id: 'attributes.operation_service',
      key: 'service',
      sort_key: 'operation_service',
      sortable: true,
      label: 'Service Details',
      width: '150px',
    },
    {
      id: 'attributes.requested_date',
      key: 'requested_date',
      sort_key: 'requested_date',
      sortable: true,
      label: 'Date',
      width: 180,
    },
    {
      id: 'attributes.check_out_date',
      key: 'check_out_date',
      sort_key: 'check_out_date',
      sortable: true,
      label: 'Check-Out Date',
      width: 180,
    },
    {
      id: 'attributes.requested_hour',
      key: 'requested_hour',
      sort_key: 'requested_hour',
      sortable: true,
      label: 'Time',
      width: '120px',
    },
    {
      id: 'attributes.id_marina.data.attributes.marina',
      key: 'id_marina',
      sort_key: 'id_marina.marina',
      sortable: true,
      label: 'Location',
      width: '150px',
    },
    {
      id: 'attributes.id_supplier.data.attributes.company_name',
      key: 'id_supplier',
      sort_key: 'id_supplier.company_name',
      sortable: true,
      label: 'Supplier',
      width: 180,
      checkbox: true,
    },
    {
      id: 'attributes.OC_BC_number_id',
      key: 'OC_BC_number_id',
      sort_key: 'OC_BC_number',
      sortable: true,
      label: 'Sales Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.OF_BF_number_id',
      key: 'OF_BF_number_id',
      sort_key: 'OF_BF_number',
      sortable: true,
      label: 'Purchase Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.account_type',
      key: 'account_type',
      sort_key: 'account_type',
      sortable: true,
      label: 'CH/BOAT',
      width: '100px',
    },
    {
      id: 'attributes.status_billing_id',
      key: 'status_billing_id',
      sort_key: 'status_billing',
      sortable: true,
      label: 'Status Billing',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.billing_notes_id',
      key: 'billing_notes_id',
      sort_key: 'billing_notes',
      sortable: true,
      label: 'Billing Notes',
      width: '150px',
      checkbox: true,
    },
  ],
  render: {
    formatHead: (key, value, { isChecked, indeterminate }) => {
      switch (key) {
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              indeterminate={indeterminate}
            />
          );
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick, isChecked) => {
      switch (key) {
        case 'status_operation_booking_id':
          const color = _.find(
            Status,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_operation_booking?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_operation_booking: value?.status_operation_booking,
              }}
              name={'status_operation_booking'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_operation_booking'
                    name='status_operation_booking'
                    label='Operational Status'
                    options={
                      value?.status_operation_booking === 'BOOKED DIRECTLY' ||
                        value?.status_operation_booking === 'AT ANCHOR'
                        ? StatusBooking
                        : StatusOperationBookingType
                    }
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_operation_booking ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_operation_booking}
                    backgroundColor={color?.hex}
                    color='#fff'
                    width={150}
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );
        case 'name_department':
          const departmentColor = _.find(
            DepartmentsConf,
            (item) => item?.id?.toUpperCase() === value?.toUpperCase()
          );
          return (
            <Box onClick={onClick}>
              {value ? (
                <RectangleChip
                  value={value}
                  backgroundColor={departmentColor?.color}
                  color='#fff'
                />
              ) : (
                '-'
              )}
            </Box>
          );
        case 'yacht_name': {
          const attendance =
            value?.attributes?.id_attendance?.data?.[0]?.attributes ||
            value?.attributes?.id_attendance?.data?.attributes ||
            value?.attributes?.id_yacht?.data?.attributes?.id_attendance?.data?.[0]?.attributes;
          const provenence =
            attendance?.id_provenence_list?.data?.attributes?.provenence?.data
              ?.attributes?.provenence ||
            value?.attributes?.provenence;

          return (
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              spacing={1}
            >
              <Stack direction={'column'} spacing={0.5}>
                <MuiTypography
                  variant='body1'
                  onClick={onClick}
                  sx={{ height: '100%', fontWeight: 'bold' }}
                >
                  {value?.attributes?.yacht_name || '-'}
                </MuiTypography>
                {provenence && (
                  <MuiTypography
                    variant='caption'
                    color='text.secondary'
                    onClick={onClick}
                  >
                    {provenence}
                  </MuiTypography>
                )}
                <Chip
                  label={`#${value?.id || '-'}`}
                  size="small"
                  sx={{ width: 'fit-content', alignSelf: 'flex-start' }}
                />
              </Stack>
            </Stack>
          );
        }
        case 'requested_date':
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CalendarIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value ? dayjs(value).format('DD-MM-YYYY') : '-'}
              </MuiTypography>
            </Stack>
          );
        case 'check_out_date':
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CalendarIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value ? dayjs(value).format('DD-MM-YYYY') : '-'}
              </MuiTypography>
            </Stack>
          );

        case 'requested_hour': {
          return value ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <AccessTimeIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {dayjs(value, 'HH:mm:ss').format('HH:mm')}
              </MuiTypography>
            </Stack>
          ) : (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              -
            </MuiTypography>
          );
        }
        case 'id_user_in_charge':
        case 'name': {
          return value ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <PersonIcon color='action' fontSize='small' />
              <MuiTypography
                sx={{ height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {`${value?.name} ${value?.surname}`}
              </MuiTypography>
            </Stack>
          ) : (
            '-'
          );
        }
        case 'status_billing_id':
          const colorBilling = _.find(
            StatusBilling,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_billing?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_billing: value?.status_billing,
              }}
              name={'status_billing'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_billing'
                    name='status_billing'
                    label='Status Billing'
                    options={StatusBilling}
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_billing ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_billing}
                    backgroundColor={colorBilling?.hex}
                    color='#fff'
                    width={150}
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );
        case 'billing_notes_id':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ billing_notes: value?.billing_notes }}
              value={value}
              name={'billing_notes'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='billing_notes'
                    name='billing_notes'
                    label='Billing Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.billing_notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'OC_BC_number_id':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_BC_number: value?.OC_BC_number }}
              value={value}
              name={'OC_BC_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_BC_number'
                    name='OC_BC_number'
                    label='Sales Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_BC_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );

        case 'OF_BF_number_id':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OF_BF_number: value?.OF_BF_number }}
              value={value}
              name={'OF_BF_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OF_BF_number'
                    name='OF_BF_number'
                    label='Purchase Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OF_BF_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'supplier_correspondent':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{
                supplier_correspondent: value?.supplier_correspondent,
              }}
              value={value}
              name={'supplier_correspondent'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='supplier_correspondent'
                    name='supplier_correspondent'
                    label='Supplier'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.supplier_correspondent || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              disabled={onClick ? false : true}
            />
          );
        case 'service_reservation_request_id':
          return value?.reservation_type ? (
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              spacing={1}>
              <RectangleChip
                value={value?.reservation_type}
                width={'auto'}
                backgroundColor={'#009ab6'}
                color='#fff'
              />
              {value?.booking ?
                <IconButton
                  component={Link}
                  to={`/booking/${value?.booking?.id}`}
                  aria-label="Prenotazioni porto"
                  color="secondary"
                  size="small"
                  target="_blank"
                  onClick={(event) => event.stopPropagation()}
                >
                  <Tooltip title={`${value?.booking?.attributes?.id_marina?.data?.attributes?.marina || ''} (${dayjs(value?.booking?.attributes?.check_in_date).format('DD-MM-YYYY HH:mm')} / ${dayjs(value.booking?.attributes?.check_out_date).format('DD-MM-YYYY HH:mm')})`}>
                    <AnchorIcon />
                  </Tooltip>
                </IconButton>
                : null}
            </Stack>
          ) : value.service ? (
            <RectangleChip
              value={value?.service}
              width={'auto'}
              backgroundColor={'#009ab6'}
              color='#fff'
            />
          ) : (
            '-'
          );
        default:
          return (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};
